<section class="popups">
  <div class="popup-header">
    <div class="header-content">
      <h4>{{data.heading | translate }}</h4>
      <img (click)="onNoClick(false)" alt="" src="assets/images/cross-icon.svg">
    </div>
  </div>
  <div class="popup-body">
    <div class="popup-content m-auto text-center">
      <img *ngIf="isActiveStatus" (click)="onNoClick(false)" alt="" src="assets/images/user-active.svg">
      <img *ngIf="!isActiveStatus" src="assets/images/delete-icon.png" alt="delete icon" />
      <p>{{data.message | translate}}</p>

    </div>
  </div>
  <hr>
  <div class="popup-footer">
    <div class="footer-content">
      <button (click)="onNoClick(true)" class="btn-style theme-btn">{{'GENERAL.Yes' | translate}}</button>
      <button (click)="onNoClick(false)" class="btn-style inactive">{{'GENERAL.No' | translate}}</button>
    </div>
  </div>
</section>